<template>
  <v-data-table
    :headers="headers"
    :items="fleetSupplierBookings"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="FleetSupplierBooking-button-new"
          @click="$router.push({
            name: 'fleet-EditFleetSupplierBooking'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'fleet-EditFleetSupplierBooking',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListFleetSupplierBooking',
  module: 'Fleet',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('fleetSupplierBookings', ['fleetSupplierBookings']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('fleetSupplierId'),
          value: 'fleetSupplier.name',
        },
        {
          text: this.$$t('vehicleId'),
          value: 'vehicle.licensePlate',
        },
        {
          text: this.$$t('startDate'),
          value: 'startDate',
        },
        {
          text: this.$$t('endDate'),
          value: 'endDate',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_fleetSupplierBookings();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('fleetSupplierBookings', ['LOAD_fleetSupplierBookings', 'DELETE_fleetSupplierBooking']),
    /** Delete FleetSupplierBooking from the collection
     */
    async remove(fleetSupplierBooking) {
      this.isLoading = true;
      await this.DELETE_fleetSupplierBooking(fleetSupplierBooking.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# FleetSupplierBooking example

'''js
<FleetSupplierBooking />
'''
</docs>
